
import { useResize } from '@/hooks/useResize';

export const useIsMobile = ({
  breakpoint = 960,
} = {}) => {
  const windowRect = useResize();
  const { width } = windowRect;
  return width < breakpoint;
};

export default useIsMobile;
